import Hls from 'hls.js';

export const addClassHandler = (item, itemClass) => {
	item.toggleClass(`${itemClass}--opened`);
};

export const hlsConfig = (idVideo, videoUrl, autoplay = false) => {
	///////////////////////////////////////////////
	const video = document.getElementById(idVideo);

	if (video) {
		if (Hls.isSupported()) {
			const hls = new Hls();

			hls.loadSource(videoUrl);
			hls.attachMedia(video);

			hls.on(Hls.Events.MANIFEST_PARSED, () => {
				if (autoplay) {
					video.play();
				}
			});
		} else if (video.canPlayType('application/vnd.apple.mpegurl')) {
			video.src = videoUrl;
			video.addEventListener('loadedmetadata', () => {
				video.play();
			});
		}
	}
};

export const accessClickHandler = ($this, currentClass, modificatorsList) => {
	$this.addClass(currentClass).parent().siblings().children().removeClass(currentClass);

	$('html').removeClass(modificatorsList.join(' ')).addClass($this.attr('rel'));
};
